import { ExclamationCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import "../../../assets/css/activeNumbers.css";
import BuyFunds from "./BuyFunds";
import { ASSIST_MAIL } from "../../../constants/AppConstants";

function TenDLCStatus({ appProperties, brandStatus, a2pStatus, campaignStatus, serviceName }) {
    return (
        <div>
            {appProperties.accountStatus === 11 ? (
                <div className="tenDlcLink" style={{ background: "#FFEBEE" }}>
                    <ExclamationCircleOutlined className="pe-2 " style={{ fontSize: "1.5rem", color: "#F44336" }} />
                    Due to low credits, your account has been suspended. To resume messaging, please recharge now
                    <BuyFunds />.
                </div>
            ) : brandStatus === "PENDING" ? (
                <div className="tenDlcLink">
                    <ExclamationCircleOutlined className="pe-2 " style={{ fontSize: "1.5rem", color: "#FF9800" }} />
                    Your brand registration has been submitted successfully; renewal may take up to 7 days.
                </div>
            ) : a2pStatus?.includes("Pending") || campaignStatus === "IN_PROGRESS" ? (
                <div className="tenDlcLinkPending">
                    <ClockCircleOutlined
                        style={{
                            fontSize: "1.6rem",
                            color: "#FFB946",
                            paddingRight: "0.5rem",
                        }}
                    />
                    <div>
                        Your 10DLC form has been successfully submitted. Please anticipate a review period of 10 to 15
                        days. For any inquiries, contact us at
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={`mailto:${ASSIST_MAIL}`}
                            style={{ paddingLeft: 5, color: "#009EFD" }}
                        >
                            {ASSIST_MAIL}.
                        </a>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default TenDLCStatus;
